import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Select from "../../Forms/Select/select";
import { required } from "../../../utils/validate";
import OptionList from "../../Forms/OptionList/optionList";

const loanPurposeOptions = [
  {
    "value": "DEBT_CONSOLIDATION",
    "text": "Debt consolidation"
  },
  {
    "value": "REFINANCING_CREDIT_CARDS",
    "text": "Refinance credit cards"
  },
  {
    "value": "LARGE_PURCHASE",
    "text": "Large purchase"
  },
  {
    "value": "PERSONAL",
    "text": "Personal"
  },
  {
    "value": "VACATION",
    "text": "Vacation"
  },
  {
    "value": "SPECIAL_OCCASION",
    "text": "Special occasion"
  },
  {
    "value": "TAXES",
    "text": "Taxes"
  },
  {
    "value": "AUTO_REPAIR",
    "text": "Auto repair"
  }
];

const LoanPurposeField = (props) => (
  <Field
    name="loanPurpose"
    label="Loan purpose"
    component={Select}
    type="select"
    validate={[required]}
    required={true}
    styles={props.styles}
    defaultValue=""
  >
    <OptionList options={loanPurposeOptions} />
  </Field>
);

LoanPurposeField.defaultProps = {
  styles: { input: [] }
};

LoanPurposeField.propTypes = {
  styles: PropTypes.shape({
    input: PropTypes.arrayOf(PropTypes.string)
  })
};

export default LoanPurposeField;
